import React from "react";
import { NavLink } from "react-router-dom";

import { withFirebase } from "../Firebase/Firebase";
import { withRouter } from "react-router-dom";

import classNames from "classnames";
import logo from "../../assets/img/brand.inverse.png";
import {withPrismic} from "../Prismic/Prismic";

class Navigation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			id: null,
			overlay: null,
			location: "/",
			isMenuActive: false
		};
		this.handleMenuToggle = this.handleMenuToggle.bind(this);
		this.dismissMenu = this.dismissMenu.bind(this);
	}
	
	NavigationAuth() {
		return (
			<ul className="menu-primary">
			<li>
			<NavLink activeClassName="-active" to="/admin/competitions">Competitions</NavLink>
			</li>
			<li>
			<a href="/" onClick={this.handleLogout}>
			Logout
			</a>
			</li>
			</ul>
		);
	}
	
	NavigationGuest = () => {
    	const { id } = this.state;
		const { menu } = this.props;
    	const competitionData = id && this.props.competitions[id];
    	const state = competitionData && competitionData.state;

    	const mi = (menu && menu.data) || {};
		return (
			<ul className="menu-primary">
			<li>
				<NavLink activeClassName="-active" to="/page/info/" >{mi.info || 'Info'}</NavLink>
				<ul>
					<li><NavLink activeClassName="-active" to="/page/info/">{mi.what_is_videos_for_change || 'What is Videos for Change?'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/categories-and-prizes/">{mi.categories_and_prizes || 'Categories and Prizes'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/how-it-works/">{mi.how_it_works || 'How it Works'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/faq/">{mi.frequently_asked_questions || 'Frequently Asked Questions'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/information-for-parents/">{mi.information_for_parents || 'Information for Parents'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/about-us/">{mi.about_us || 'About Us'}</NavLink></li>
				</ul>
			</li>
			<li>
				<NavLink activeClassName="-active" to="/page/resources-students/">{mi.resources || 'Resources'}</NavLink>
				<ul>
					<li><NavLink activeClassName="-active" to="/page/resources-students/">{mi.for_students || 'For Students'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/resources-teachers/">{mi.for_teachers || 'For Teachers'}</NavLink></li>
					<li><NavLink activeClassName="-active" to="/page/social-issues/">{mi.social_issues || 'Social Issues'}</NavLink></li>
				</ul>
			</li>
			<li><NavLink activeClassName="-active" to="/page/videos/">{mi.videos || 'Videos'}</NavLink></li>
			<li><NavLink activeClassName="-active" to="/page/summit/">{mi.summit || 'Summit'}</NavLink></li>
			<li><NavLink activeClassName="-active" to="/page/global-page/">{mi.global || 'Global'}</NavLink></li>
			<li>
				<NavLink activeClassName="-active" to="/competition/2019/">
					{state === 'voting' ? 'Vote' : (state === 'winners' ? mi.winners || 'Winners' : mi.vote || 'Vote') }
				</NavLink>
			</li>
			</ul>
		);
	}
	
	dismissMenu() {
		if (this.state.isMenuActive) {
			this.setState({ isMenuActive: false });
		}
	}
	
	handleLogout = e => {
		e.preventDefault();
		this.props.methods.signOut();
	};
	
	handleMenuToggle(state) {
		this.setState({ isMenuActive: !state });
	}

  async componentDidMount() {
    const { match } = this.props
    const slug = match && match.params && match.params.slug
    this.props.prismic.getMenu(match.params.lang);
    try {
      const id = await this.props.methods.getCompetitionBySlug(slug);
      this.setState({ id });
    } catch (error) {
      this.setState({ error: true });
    }
	}
	
	componentDidUpdate() {
		if (
			this.props.location &&
			this.props.location.pathname &&
			this.state.location !== this.props.location.pathname
		) {
			this.dismissMenu();
			this.setState({ location: this.props.location.pathname });
		}
	}

	navClasses() {
		return classNames({
			"primary-navigation": true,
			[`-${this.props.path}`]: true,
			"-open": this.state.isMenuActive
		});
	}
	
	toggleClasses() {
		return classNames({
			"menu-toggle": true,
			"-active": this.state.isMenuActive
		});
	}
	
	menuClasses() {
		return classNames({
			"main-menu": true,
			"-active": this.state.isMenuActive
		});
	}
	
	render() {
		return (
			<nav className={this.navClasses()}>
			<div className="container">
			<div className={this.menuClasses()}>
			{this.props.authUser && this.props.authUser.isAdmin
				? this.NavigationAuth()
				: this.NavigationGuest()}
				</div>
				<div className="brand">
				<a href="/">
				<img src={logo} alt="Videos for Change" />
				</a>
				</div>
				
				<div
				className={this.toggleClasses()}
				onClick={() => {
					this.handleMenuToggle(this.state.isMenuActive);
				}}
				>
				<div className="box">
				<div className="inner" />
				</div>
				</div>
				</div>
				</nav>
			);
		}
	}
	export default withRouter(withFirebase(withPrismic(Navigation)));
	


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js